const reportsES = {
  // namespace your translation keys with "rpt", i.e.
  // 'report.lorem_ipsum': 'Lorem Ipsum'
  'report.by_bill_time': 'Por tiempo de factura',
  'report.by_sales': 'Por ventas',
  'report.by_close_time': 'Hora de cierre de facturación',
  'report.by_start_time': 'Hora de inicio de facturación',
  'report.by_sent_time': 'Hora de envío del artículo de la factura',
  'report.net_sales': 'Ventas netas',
  'report.gross_sales': 'Ventas brutas',
  'report.step': 'Paso',
  'report.report_format_desc':
    'Por favor tenga en cuenta que recibirá un archivo .csv para cada informe y un archivo .xlsx con varias hojas (una hoja para cada informe).',
  'report.scheduled_report_emails_desc':
    'Usted puede ingresar múltiples correos electrónicos separados por una coma',
  'report.daily-tab': 'Ventas diarias',
  'report.hourly-tab': 'Ventas por hora',
  'report.voids': 'Anulados',
  'report.discounts': 'Descuentos',
  'report.weekly': 'Semanal',
  'report.monthly': 'Mensual',
  'report.choose_scheduled_multi':
    'Por favor elija los reportes que quiere incluir en su informe programado.',
  'report.select_date': 'Seleccione la fecha de inicio',
  'report.filter_by_date': '[ES] Filter by Date:',
  'report.filter_by_status': '[ES] Filter by Status:',
  'report.filter_by_channel': '[ES] Filter by Channel:',
  'report.continue_scheduling': 'Continuar programando',
  'report.not_scheduled_yet_confirm_create':
    'Su reporte aún no ha sido programado. ¿Está seguro de que desea volver?',
  'report.will_not_be_scheduled_create':
    'Tenga en cuenta que su reporte no se programará y perderá cualquier progreso que haya realizado.',
  'report.not_scheduled_yet_confirm_update':
    'Sus cambios aún no se han guardado. ¿Está seguro de que desea volver?',
  'report.will_not_be_scheduled_update':
    'Tenga en cuenta que sus cambios no se guardarán y tendrá que empezar de nuevo la próxima vez.',
  'report.success': '¡Exitoso!',
  'report.has_been_scheduled': 'Su informe ha sido programado',
  'report.schedule_report_title_required': 'Por favor ingrese el título',
  'report.send_to': 'Enviar a',
  'report.select_at_least_one_venue': 'Por favor selecciona al menos un establecimiento',
  'report.select_at_least_one_report': 'Por favor selecciona al menos un reporte',
  'report.invalid_email': 'Por favor introduce una dirección de correo electrónico válida',
  'report.duplicate_email': 'Elimine los correos electrónicos duplicados',
  'report.email_add_required': 'Por favor introduzca al menos una dirección de correo electrónico',
  'report.validation_required_min': 'Por favor, seleccione al menos una sección',
  'report.validation_required': 'Este campo es obligatorio',
  'report.select_venues': 'Seleccionar Establecimientos',
  'report.warning_deleting_scheduled_report_sub':
    'Esta acción eliminará permanentemente su informe. Usted no podrá recuperar esta información.',
  'report.schedule_report_freq_daily': 'Recibirá su reporte todos los días.',
  'report.schedule_report_freq_weekly':
    'Usted recibirá su reporte semanalmente. Su reporte va a consolidar la información del inicio al fin de la semana de tu servicio semanal anterior.',
  'report.schedule_report_freq_2weeks':
    'Usted recibirá su reporte cada 2 semanas. Puede seleccionar la fecha de inicio (cualquier día hasta 2 semanas anterior al día actual).',
  'report.schedule_report_freq_monthly':
    'Usted recibirá su reporte el primer día de cada mes. Su reporte va a consolidar la información del inicio al fin del mes anterior.',
  'report.next_report_date_column': 'Fecha del próximo informe (A/M/D)',
  'report.next_report_date': 'Fecha de próximo reporte:',
  'report.merging_report_title':
    'Los reportes "{{reportName}}" y "{{reportNameTwo}}" serán unidos en el nuevo reporte "{{mergeReportName}}".',
  'report.merging_report_merge_body':
    'En las siguientes semanas uniremos los reportes "{{reportName}}" and "{{reportNameTwo}}" en un único reporte llamado "{{mergeReportName}}". Usted puede encontrar este nuevo reporte en Reportes > {{mergeSectionName}} y será capaz de descargarlo en el formato CSV o XLS. Previamente programado para recibir estos dos reportes, tenga en consideración que recibirá un único reporte de ahora en adelante.',
  'report.reopened_bills': 'Cuentas Reabiertas',
  'report.gift_card_analysis': 'Análisis de tarjetas de regalo',
  'report.sales': 'Ventas',
  'report.activity': 'Actividad',
  'report.takeout_types': 'Tipos de comida para llevar',
  'report.deleted_items': 'Objetos eliminados',
  'report.tax_exclusion': 'Reglas de exclusión de Impuestos',
  'report.no_sale': 'Objetos no vendidos',
  'report.name_scheduled_report': 'Nombra el informe programado',
  'report.indicates_required_field': 'indica un campo obligatorio.',
  'report.server': 'Mozo',
  'report.date_and_timestamp': 'Fecha/sello de hora',
  'report.reason': 'Motivo',
  'report.amount': 'Amount (Monto)',
  'report.register': 'Caja registradora',
  'report.comment': 'Comentario',
  'report.accounts': 'Cuentas',
  'report.accounts_deposits_payments': 'Mostrar depósitos/pagos',
  'report.payins': 'Cuentas por cobrar',
  'report.payouts': 'Cuentas por pagar',
  'report.payins_payouts': 'Cuentas por pagar/Cuentas por cobrar',
  'report.updated_at': 'Actualizado por última vez el',
  'report.last_updated_with_time': 'Actualizado por última vez {{timestamp}}',
  'report.updated_just_now': 'Actualizado hace un momento',
  'report.report_merged_into_staff_performance':
    'Este informe se fusionó con el informe de rendimiento del personal y se movió a la sección Laboral',
  'report.moved_to_other_section': 'Este informe se ha trasladado a la Sección {{section}}',
  'report.detailed_sales': 'Ventas detalladas',
  'report.decommission_title': '{{currentName}} se fusionará con el reporte {{newReportName}}',
  'report.decommission_body':
    'El reporte {{currentName}} se ha fusionado con el reporte "{{newReportName}}" en la sección {{newSection}}. Podrá descargar el informe en su formato preferido.',
  'report.single_vs_multi_selection':
    'El numero de informes disponibles cambiarán según la cantidad de restaurantes seleccionados; cambiar el número de restaurantes seleccionados después de elegir los informes borrará la selección del informe y tendrá que seleccionar su(s) informe(s) nuevamente.',
  'report.print_this_report': 'Imprimir este informe',
  'report.report_range': 'Rango del informe',
  'report.number_of_venues': 'Cant. de lugares',
  'report.venues_included': 'Lugares incluidos',
  'report.report_summary': 'Resumen del informe',
  'report.incompatible_browser_title': 'Navegador incompatible',
  'report.incompatible_browser_body':
    'Recomendamos usar Google Chrome o Mozilla Firefox para imprimir reportes.',
  'report.incompatible_browser_button': 'Imprimir de todos modos',
  'report.printing_in_progress': 'Preparando tu informe...',
  'report.printing_disclaimer':
    'Ten en cuenta que los grandes volúmenes de datos pueden tardar más en imprimirse. Recomendamos imprimir informes con volúmenes de datos más pequeños para garantizar una impresión exitosa.',
  'report.send_report': 'Enviar Reporte',
  'report.send_reports': 'Enviar Reportes',
  'report.send_report_desc':
    'Por favor seleccione su formato preferido y agregue al menos un correo electrónico para enviar su reporte.',
  'report.report_format': 'Formato del reporte',
  'report.send_report_email_placeholder': 'Ingrese las direcciones de correo electrónico',
  'report.send_report_email_hint':
    'Puede ingresar varios correos electrónicos separados por una coma.',
  'report.success_sent': 'Tu reporte ha sido enviado satisfactoriamente.',
  'report.error_sent': 'Su informe no pudo ser enviado. Inténtalo de nuevo por favor.',
  'report.dashboard': '[ES] Dashboard',
  'report.advanced_reporting': 'Informes avanzados',
  'report.all_reports_library': '[ES] All Reports Library',
  'report.all_reports_library_search_placeholder': '[ES] Search Reports',
  'report.all_reports_library_filter_by': '[ES] Filter by',
  'report.all_reports_library_column_report_name': '[ES] Report Name',
  'report.all_reports_library_column_report_areas': '[ES] Report Areas',
  'report.all_reports_library_new_badge': '[ES] New!',
  'report.all_reports_library_empty': '[ES] No reports match your search.',
  'report.all_reports_library_error':
    '[ES] The report library could not be loaded. Please try again.',
  'report.all_reports_library_clear_selection': '[ES] Clear Selection',
  'report.all_reports_library_pin': '[ES] Pin report',
  'report.all_reports_library_unpin': '[ES] Unpin report',
  'report.all_reports_library_pin_error':
    "[ES] We couldn't save your pinned reports. Please try again.",
  'report.breadcrumb_back': '[ES] Back',
  'report.operational_dashboard': '[ES] Operational Dashboard',
  'report.dashboard_top_sales_categories': 'Principales Categorías de Ventas',
  'report.dashboard_top_shifts': 'Turnos Superiores',
  'report.dashboard_tender_types': 'Tipos de Licitación',
  'report.dashboard_top_menu_groups': 'Grupos de Menú Principales',
  'report.dashboard_top_discounts_voids': 'Descuentos y Vacíos Principales',
  'report.dashboard_top_menu_items': 'Elementos del Menú Superior',
  'report.customize_dashboard_view': '[ES] Customize View',
  'report.dashboard_customize_subtitle':
    '[ES] Customization Mode: Drag cards to reorder. Up to 5 reports load expanded by default. All others will load collapsed.',
  'report.dashboard_favourites_hint':
    '[ES] Add up to 5 reports above to load expanded on page load. Reports below will remain collapsed by default.',
  'report.dashboard_favourites_empty_hint':
    '[ES] Drag reports here to load them expanded on page load.',
  'report.dashboard_save_error': "[ES] We couldn't save your dashboard layout. Please try again.",
  'report.dashboard_manage_reports': '[ES] Manage Reports',
  'report.dashboard_no_reports_available': '[ES] No reports available.',
  'report.dashboard_view_full_report': '[ES] View Full Report',
  'report.dashboard_expand_view': '[ES] Expand View',
  'report.dashboard_drag_handle': '[ES] Drag to reorder',
  'report.dashboard_toggle_expanded': '[ES] Toggle expanded',
  'report.dashboard_card_actions': '[ES] Card actions',
  'report.dashboard_expand': '[ES] Expand',
  'report.dashboard_collapse': '[ES] Collapse',
  'report.dashboard_hide': '[ES] Hide',
  'report.dashboard_add_to_favourites': '[ES] Add to Favorites',
  'report.dashboard_remove_from_favourites': '[ES] Remove from Favorites',
  'report.dashboard_expanded_on_page_load': '[ES] Expanded on page load',
  'report.dashboard_card_error':
    "[ES] We couldn't load this report. Select Update Report to try again.",
  'report.dashboard_vs_past_days': '[ES] past {{n}}d',
  'report.dashboard_vs_past_weeks': '[ES] past {{n}}w',
  'report.dashboard_vs_past_months': '[ES] past {{n}}m',
  'report.dashboard_delta_increase': '[ES] Increased',
  'report.dashboard_delta_decrease': '[ES] Decreased',
  'report.dashboard_delta_unavailable': '[ES] No comparison available',
  'report.no_bills_found': 'No se encontraron facturas',
  'report.reports': 'Reportes',
  'report.select_other_reports': 'Seleccionar Otro(s) Reporte(s)',
  'report.pos_to_cloud_reports_limited_data':
    'Por favor actualiza TouchBistro POS a la version 10.4 o arriba para acceder a este reporte. Una vez actualizado, tendrás acceso a la información desde esa fecha en adelante hasta que agreguemos el historial de información.',
  'report.pos_to_cloud_reports_limited_data_gift_card':
    'Por favor actualiza TouchBistro POS a la version 10.7 o arriba para acceder a este reporte. Una vez actualizado, tendrás acceso a la información desde esa fecha en adelante hasta que agreguemos el historial de información.',
  'report.week_selector': 'Seleccionar Semana',
  'report.month_selector': 'Seleccionar Mes',
  'report.staff_summary': 'Resumen del personal',
  'report.continue_editing': 'Seguir Editando',
  'report.configurable_reports': 'Reportes Configurables',
  'report.view-reports': 'Ver los informes',
  'report.view-reports-description':
    'Seleccione una categoría y luego un informe que le gustaría ver. Personalice y guarde su nuevo informe para acceder rápidamente a él para futuro uso.',
  'report.saved-reports': 'Saved Reports',
  'report.no_saved_reports_title': 'No hay informes guardados',
  'report.no_saved_reports_message':
    'Actualmente no tiene ningún informe guardado. Vea, personalice y guarde los informes para acceder a ellos aquí.',
  'report.description': 'Descripción',
  'report.category': 'Categorías',
  'report.created_at': 'Creado',
  'report.select_a_category': 'Seleccione una Categoría',
  'report.saved_report_desc': '[ES] View, edit or favorite your saved reports.',
  'report.basic_list_view_update_prompt':
    '¿Está seguro de que desea actualizar {{candidateForUpdate}}?',
  'report.warning_favorite_report': '[ES] This action will set your report as favorite.',
  'report.end_of_day': 'Fin del dia',
  'report.operational_summary': '[ES] Operational Summary',
  'report.update_custom_report_error': 'Hubo un error al actualizar su informe.',
  'report.report_updated': 'Reporte actualizado',
  'report.all_reports': 'Todos los Reportes',
  'report.print': 'Imprimir',
  'report.select_reports': 'Seleccionar Reportes',
  'report.end_of_day_report': 'Informe de fin de día',
  'report.shift_report': 'Reporte de Turno',
  'report.back_to_shift_management': '[ES] Back To Shift Management',
  'report.shift_summary': 'Reporte de Resumen de Turno',
  'report.no_data': 'No hay datos disponibles',
  'report.all_selected': 'Todo seleccionado',
  'report.edit_columns': 'Editar columnas',
  'report.save_report_as': 'Guardar Informe Como',
  'report.new_custom_report': 'Nuevo Informe',
  'report.update_custom_report': 'Actualizar Informe Actual',
  'report.saved_report_name': 'Reporte Nombre',
  'report.optional_description': 'Agregue una nota (opcional)',
  'report.save_report_title': 'Guardar Los Informes',
  'report.report_update_success_notification': 'El informe {{reportName}} ha sido actualizado',
  'report.day_part_name': 'Nombre de la parte del día',
  'report.start_and_end_time': 'Hora de inicio y hora de finalización',
  'report.scheduled_days': 'Días programados',
  'report.no_data_for_shift': 'Datos no disponibles {{date}}',
  'report.no_data_for_shift_to_show_data':
    'Para mostrar los datos de su informe de turno, seleccione las fechas en las que marcó su entrada o salida. Las fechas intermedias no mostrarán ningún dato.',
  'report.no_data_for_shift_reminder':
    'Un recordatorio para marcar la salida para evitar turnos que abarquen varios días.',
  'report.eod_report.sales-tax-and-tip-summary': '[ES] Sales, Tax, and Tip Summary',
  'report.eod_report.sales-summary': '[ES] Detailed Sales Summary',
  'report.eod_report.sales-by-category': '[ES] Sales By Sales Category',
  'report.eod_report.sales-by-section': '[ES] Sales By Section',
  'report.eod_report.gift-card-sales': '[ES] Gift Card Sales',
  'report.eod_report.labor-summary': '[ES] Detailed Labor Summary',
  'report.eod_report.tips-by-employee': '[ES] Tips By Employee',
  'report.eod_report.tips-summary': '[ES] Tips Summary',
  'report.eod_report.payments-summary': '[ES] Payments Summary',
  'report.eod_report.payment-by-payment-type': '[ES] Payments By Payment Type',
  'report.eod_report.tip-outs-summary': '[ES] Tip Outs',
  'report.eod_report.accounts': '[ES] Accounts Summary',
  'report.eod_report.payouts-payins': '[ES] Payouts/Payins',
  'report.eod_report.cash-deposit': '[ES] Cash Deposit',
  'report.eod_report.taxes': '[ES] Tax Summary',
  'report.eod_report.sales-by-order-type': '[ES] Sales By Order Type',
  'report.eod_report.discounts': '[ES] Discounts',
  'report.eod_report.service-charges': '[ES] Service Charges',
  'report.operational_summary_report.sales-tax-and-tip-summary': '[ES] Sales Summary',
  'report.operational_summary_report.sales-summary': '[ES] Detailed Sales Summary',
  'report.operational_summary_report.sales-by-category': '[ES] Sales By Sales Category',
  'report.operational_summary_report.sales-by-section': '[ES] Sales By Section',
  'report.operational_summary_report.gift-card-sales': '[ES] Gift Card Sales',
  'report.operational_summary_report.labor-summary': '[ES] Detailed Labor Summary',
  'report.operational_summary_report.tips-by-employee': '[ES] Tips By Employee',
  'report.operational_summary_report.tips-summary': '[ES] Tips Summary',
  'report.operational_summary_report.payments-summary': '[ES] Payments Summary',
  'report.operational_summary_report.payment-by-payment-type': '[ES] Payments By Payment Type',
  'report.operational_summary_report.tip-outs-summary': '[ES] Tip Outs',
  'report.operational_summary_report.accounts': '[ES] Accounts Summary',
  'report.operational_summary_report.payouts-payins': '[ES] Payouts/Payins',
  'report.operational_summary_report.cash-deposit': '[ES] Cash Deposit',
  'report.operational_summary_report.taxes': '[ES] Tax Summary',
  'report.operational_summary_report.sales-by-order-type': '[ES] Sales By Order Type',
  'report.operational_summary_report.discounts': '[ES] Discounts',
  'report.operational_summary_report.service-charges': '[ES] Service Charges',
  'report.generating_report': '[ES] Generating Your Report',
  'report.generating_report_message': '[ES] Please wait a moment while we generate your report',
  'report.purchases': '[ES] Purchases',
  'report.explain_this_report': '[ES] Explain This Report',
  'report.advanced_filters': '[ES] Advanced Filters',
  'report.selected_filters': '[ES] Selected Filters',
  'report.all_statuses': '[ES] All Statuses',
  'report.all_channels': '[ES] All Channels',
  'report.deposits': '[ES] Deposits',
  'report.table.date_time': '[ES] DATE/TIME',
  'report.table.status': '[ES] STATUS',
  'report.table.reasons': '[ES] REASONS',
  'report.table.total_amount': '[ES] TOTAL AMOUNT',
  'report.table.tip_amount': '[ES] TIP AMOUNT',
  'report.table.fees': '[ES] FEES',
  'report.table.network_state': '[ES] NETWORK STATE',
  'report.table.card_type': '[ES] CARD TYPE',
  'report.table.card_number': '[ES] CARD NUMBER',
  'report.table.bill_number': '[ES] BILL NUMBER',
  'report.table.order_number': '[ES] ORDER NUMBER',
  'report.table.transaction_id': '[ES] TRANSACTION ID',
  'report.table.auth_id': '[ES] AUTH ID',
  'report.overflow_warning':
    'Se devolvieron más de {{limit}} registros. Solo se muestran {{limit}} de {{rows}} registros.',
  'report.multi_location_summary': '[ES] Multi-location Summary',
  'report.payments': '[ES] Payments',
  'report.product_mix': '[ES] Product Mix',
  'report.labor_report': '[ES] Labor',
  'report.sales_by_period': '[ES] Sales by Period',
  'report.display_time_as': '[ES] Display Time As',
  'report.display_time_as.bill_start': '[ES] Bill Start Time',
  'report.display_time_as.bill_paid': '[ES] Bill Paid Time',
  'report.display_time_as.bill_item_sent': '[ES] Bill Item Sent Time',
  'report.tax_summary': '[ES] Tax Summary',
  'report.filter': 'Filtro',
  'report.filters': 'Filtros',
  'report.find': 'Buscar',
  'report.add_filter': 'Agregar Filtro',
  'report.search_filters_placeholder': 'Buscar filtros',
  'report.search_filters_no_results': 'No se encontraron filtros',
  'report.filter.sales_category': 'Categoría de ventas',
  'report.filter.menu_group': 'Grupo del menú',
  'report.filter.menu_item': 'Artículo del menú',
  'report.filter.section': 'Sección',
  'report.filter.order_type': 'Tipo de orden',
  'report.filter.provider': 'Proveedor',
  'report.filter.staff_member': 'Miembro del personal',
  'report.filter.net_sales': 'Ventas netas ($)',
  'report.get_this_report': '[ES] Get this Report',
  'report.reset_to_default': '[ES] Reset to Default',
  'report.update_report': '[ES] Update Report',
  'report.select_all': 'Seleccionar todo',
  'report.view_options': 'Opciones de vista',
  'report.report_type': '[ES] Report Type',
  'report.v2.no_data':
    "[ES] Your parameters didn't return any records. Please adjust your parameters and try again.",
  'report.v2.data_overflow_warning':
    '[ES] Showing the first {{limit}} rows of {{totalRowCount}}. Totals cannot be displayed for partial results. Refine filters to narrow results or view more data with Get this Report.',
  'report.v2.export_description':
    '[ES] CSV exports up to {{csvLimit}} rows. XLSX and PDF exports up to {{xlsxLimit}} rows.',
  'report.v2.export_max_rows': '[ES] Max {{limit}} rows',
  'report.v2.dashboard_export_csv_description': '[ES] Downloads as a ZIP, one file per report',
  'report.v2.pending_changes_banner_prefix': '[ES] Report parameters have been modified. Click',
  'report.v2.pending_changes_banner_suffix': '[ES] to fetch updated data.',
  'report.v2.generic_error': "[ES] We couldn't generate your report.",
  'report.v2.export_timeout': '[ES] Your report is taking longer than expected. Please try again.',
  'report.v2.print_error': '[ES] Unable to open print preview.',
  'report.v2.debug_config_invalid_json': '[ES] That configuration is not valid JSON.',
  'report.v2.reset_filters_message': '[ES] We reset your filters to prevent a loading error.',
  'report.v2.please_enter_a_value': 'Por favor ingrese un valor',
  'report.v2.please_select_at_least_one_value': 'Por favor seleccione al menos un valor',
  'report.v2.customize_report': '[ES] Customize Report',
  'report.v2.dimensions': '[ES] Dimensions',
  'report.v2.measures': '[ES] Measures',
  'report.v2.rows': '[ES] Rows',
  'report.v2.columns': '[ES] Columns',
  'report.v2.values': '[ES] Values',
  'report.v2.description.more_information': '[ES] More information',
  'report.v2.description.close': '[ES] Close',
  'report.v2.description.about_label': '[ES] About {{label}}',
  'report.v2.description.about': '[ES] About this item',
  'report.v2.description.about_column': '[ES] About This Column',
  'report.v2.description.dimensions_in_report': '[ES] Dimensions in this report:',
  'report.v2.description.section_rows':
    '[ES] Fields listed down the side of the report, one group per row.',
  'report.v2.description.section_columns':
    '[ES] Fields spread across the top of the report, turning their values into columns.',
  'report.v2.description.section_columns_long':
    "[ES] Pivoting turns each value of the field into its own column — a report pivoted by Month gets one column per month, repeated for every measure in Values.\n\nThat multiplies the report's width: three measures across twelve months is thirty-six columns. Pivot by a field with few values, or the report gets unreadable quickly.",
  'report.v2.description.section_values': '[ES] The numbers calculated for each row of the report.',
  'report.v2.description.section_dimensions': '[ES] Fields you can group or pivot the report by.',
  'report.v2.description.section_measures': '[ES] Numbers the report can calculate.',
  'report.v2.drag_here_row_groups': '[ES] Drag here to set row groups',
  'report.v2.drag_here_column_groups': '[ES] Drag here to set column groups',
  'report.v2.drag_here_measures': '[ES] Drag here to aggregate measures',
  'report.v2.search_fields': '[ES] Search',
  'report.v2.set': '[ES] Set',
  'report.start': '[ES] Start',
  'report.end': '[ES] End',
  'report.date_range': '[ES] Date Range',
  'report.daily_window': '[ES] Daily Window',
  'report.day_parts_may_take_time': 'Los nuevos Day Parts pueden tardar en mostrar resultados.',
}

export default reportsES
